import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { colors } from "../../styles";
import Avatar from "./Avatar";

const NameCardStyled = styled.div`
  overflow: hidden;
  display: flex;
  align-items: center;
`;

const NameCardText = styled.div`
  margin-left: 10px;
  text-align: start;
`;

const FirstLine = styled.a`
  padding: 0;
  display: block;
  color: #010101;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-decoration: inherit;
  margin-bottom: ${(props) => (props.singleLine ? "" : "")};
  font-family: Nunito;
  font-size: 18px;
  font-weight: 700;
  line-height: 25px;
  letter-spacing: 0.1em;
  text-align: left;
  text-transform: uppercase;

  &:hover {
    color: initial;
  }
`;

const SecondLine = styled.div`
  // font-size: 12px;
  // color: ${colors.colorLightGray};
  font-family: 'Nunito';
  font-style: normal;
  font-weight: 300;
  font-size: 13px;
  line-height: 18px;
  color: #4860D9;
`;

function NameCard({
  user,
  customer,
  contact,
  firstLine,
  secondLine,
  singleLine,
  avatarSize,
  firstClassName,
  showInitials,
  showTeamColorPattern,
}) {
  let first;
  let second;

  if (user || firstLine || secondLine) {
    first =
      firstLine ||
      user.name ||
      (singleLine && (user.name || user.email || "N/A"));
    second = !singleLine && (secondLine || `@${user.user_name}`);
  } else if (customer) {
    first =
      firstLine ||
      customer.name ||
      (singleLine && (customer.name || customer.email || "N/A"));
    second = !singleLine && (secondLine || customer.email || "N/A");
  } else if (contact) {
    first =
      firstLine ||
      contact.phone_number ||
      (singleLine && (contact.phone_number || contact.email || "N/A"));
    second = !singleLine && (secondLine || "N/A");
  }

  return (
    <NameCardStyled>
      <Avatar
        showTeamColorPattern={showTeamColorPattern}
        showInitials={showInitials}
        user={user}
        customer={customer}
        contact={contact}
        size={avatarSize}
      />
      <NameCardText>
        <FirstLine className={firstClassName} singleLine={singleLine}>
          {first}
        </FirstLine>
        {second && <SecondLine>{second}</SecondLine>}
      </NameCardText>
    </NameCardStyled>
  );
}

NameCard.propTypes = {
  user: PropTypes.object,
  customer: PropTypes.object,
  contact: PropTypes.object,
  singleLine: PropTypes.bool,
  firstLine: PropTypes.node,
  secondLine: PropTypes.node,
  avatarSize: PropTypes.number,
  url: PropTypes.string,
  isUser: PropTypes.bool,
};
NameCard.Avatar = Avatar;

export default NameCard;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/nameCard/NameCard.js